/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileWithStatistics } from '../../models/profile-with-statistics';

export interface ListProfilesByScore$Params {
  offset: number;
  limit: number;

/**
 * Company types filter, separated by ','. Example 'GOVERNMENT_AGENCY,EDUCATIONAL_INSTITUTION'.
 */
  companyType?: string;

/**
 * Filter by country (only one). Example 'SK'.
 */
  country?: string;
}

export function listProfilesByScore(http: HttpClient, rootUrl: string, params: ListProfilesByScore$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileWithStatistics>>> {
  const rb = new RequestBuilder(rootUrl, listProfilesByScore.PATH, 'get');
  if (params) {
    rb.path('offset', params.offset, {});
    rb.path('limit', params.limit, {});
    rb.query('companyType', params.companyType, {});
    rb.query('country', params.country, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProfileWithStatistics>>;
    })
  );
}

listProfilesByScore.PATH = '/rest/profile/rank/score/{offset}/{limit}';
